<template>
  <div class="news-side-bar-wrap">
    <div class="search-input">
      <a-input-search
        placeholder="Search News"
        enter-button
        @search="onSearch"
      />
    </div>
    <div class="side-content">
      <div class="box-wrapper categories">
        <div class="head-title">Categories</div>
        <ul class="list category-list">
          <li v-for="(category, index) in categories" :key="index">
            <div
              @click="handleCategoryClick(category.id)"
              class="name"
              :class="{ active: selectedCategory === category.id }"
            >
              {{ category.name }}
            </div>
          </li>
        </ul>
      </div>
      <div class="box-wrapper tags">
        <div class="head-title">Tags</div>
        <ul class="list tag-list">
          <li
            @click="handleTagClick(tag.id)"
            v-for="(tag, index) in tags"
            :key="index"
            :class="{ active: selectedTag === tag.id }"
          >
            {{ tag.name }}
          </li>
        </ul>
      </div>
      <div class="box-wrapper recent-news">
        <div class="head-title">Recent News</div>
        <ul class="list news-list">
          <li
            class="news-card"
            v-for="(news, index) in recentNews"
            :key="index"
            @click="handleLatestNewsClick(news.id)"
          >
            <div class="img-wrap">
              <img :src="generateImageUrl(news.image)" alt="New Title" />
            </div>
            <div class="text-detail">
              <div class="title">{{ news.title }}</div>
              <div class="extra-info">
                <div class="date-info">
                  <a-icon type="clock-circle" />{{
                    news.createdAt | humanizeDate
                  }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Base } from "@/models";

const STORE_KEY = "newsStore";

export default {
  name: "NewsSideBar",
  props: {
    selectedCategory: {
      type: String,
      default: null
    },
    selectedTag: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      newsList: []
    };
  },
  computed: {
    ...mapGetters({
      tags: `${STORE_KEY}/tags`,
      tagsLoading: `${STORE_KEY}/tagsLoading`,
      categories: `${STORE_KEY}/categories`,
      categoriesLoading: `${STORE_KEY}/categoriesLoading`,
      news: `${STORE_KEY}/news`,
      latestNews: `${STORE_KEY}/latestNews`,
      singleNews: `${STORE_KEY}/singleNews`
    }),
    recentNews() {
      return this.latestNews
        .filter(news => news.id !== this.singleNews.id)
        .filter((_n, index) => index < 4);
    }
  },
  methods: {
    onSearch(value) {
      this.$emit("search", value);
    },
    handleCategoryClick(id) {
      this.$emit("category-click", id);
    },
    handleTagClick(id) {
      this.$emit("tag-click", id);
    },
    handleLatestNewsClick(id) {
      this.$route.params.profileId
        ? this.$router.push(`/${this.$route.params.profileId}/news/${id}`)
        : this.$router.push(`/news/${id}`);
    }
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getCategories`);
    this.$store.dispatch(`${STORE_KEY}/getTags`);
    this.$store.dispatch(`${STORE_KEY}/getLatestNews`, {
      limit: 4,
      page: 1,
      sort: "-createdAt"
    });
  },
  watch: {
    news(newVal) {
      if (this.newsList.length === 0)
        this.newsList = newVal.filter((_n, index) => index < 3);
    }
  }
};
</script>

<style lang="scss">
.news-side-bar-wrap {
  .search-input {
    margin-bottom: 28px;
    input {
      height: 40px;
      border: 1px solid #c4c4c4 !important;
      color: #000;
      border-radius: 0;
      font-weight: 400;
      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #838485 !important;
        opacity: 0.6;
        font-weight: 400;
      }
      &::-moz-placeholder {
        /* Firefox 19+ */
        color: #838485 !important;
        opacity: 0.6;
        font-weight: 400;
      }
      &:-ms-input-placeholder {
        /* IE 10+ */
        color: #838485 !important;
        opacity: 0.6;
        font-weight: 400;
      }
      &:-moz-placeholder {
        /* Firefox 18- */
        color: #838485 !important;
        opacity: 0.6;
        font-weight: 400;
      }
    }
    .ant-btn {
      height: 40px;
      background: #2b3490;
      border-color: #2b3490;
      border-radius: 0;
    }
  }
  .side-content {
    .box-wrapper {
      margin-bottom: 30px;
      padding: 30px 20px;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 4px 10px 5px rgba(209, 209, 209, 0.6);
      .head-title {
        width: fit-content;
        text-transform: uppercase;
        font-size: 14px;
        color: #4f5152;
        position: relative;
        font-weight: 600;
        padding-left: 10px;
        margin-bottom: 25px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 4px;
          height: 100%;
          background: #d23129;
        }
      }
      .list {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 15px 0;
          border-bottom: 1px solid #ccc;
          .name {
            font-size: 14px;
            font-weight: 500;
            color: #8d8d8d;
            &:hover {
              color: black;
            }
          }
          .number {
            padding: 0 8px;
            border-radius: 3px;
            background: #ddd;
            color: #000;
            font-weight: 500;
            font-size: 12px;
            line-height: 22px;
          }
          &:first-child {
            padding-top: 0;
          }
          &:last-child {
            padding-bottom: 0;
            border-bottom: none;
          }
        }
        &.tag-list {
          display: flex;
          flex-wrap: wrap;
          li {
            padding: 0 10px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            line-height: 28px;
            color: #8d8d8d;
            text-transform: lowercase;
            margin-right: 5px;
            margin-bottom: 5px;
            display: block;
            border: 1px solid #ddd;
            &:hover {
              color: black;
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      &.recent-news {
        .news-card {
          display: flex;
          justify-self: start;
          padding-top: 25px;
          .img-wrap {
            width: 70px;
            height: 70px !important;
            border-radius: 4px;
            overflow: hidden;
            left: 0;
            top: 0;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .text-detail {
            width: calc(100% - 70px);
            padding: 0 0 10px 15px;
            .title {
              text-transform: uppercase;
              font-size: 12px;
              color: #000;
              font-weight: 500;
            }
            .extra-info {
              padding-top: 20px;
              display: flex;
              align-items: center;
              > div {
                margin-right: 15px;
                font-size: 12px;
                color: #7a8b91;
                font-weight: 500;
                .anticon {
                  color: #d73228;
                  margin-right: 8px;
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
.active {
  color: black !important;
}

@media only screen and (max-width: 991px) {
  .news-side-bar-wrap {
    max-width: 350px;
    margin: 0 auto;
  }
}
</style>
